// @flow
import typeof { HTTP_METHODS } from "../../constants/Constants";
import type { ModularUIModel } from "../../models/types";
import type { TargetModel } from "../../modularui/types";

export type RequestURLOptions = {
  url: string,
};

export type RequestBaseOptions = {
  origin?: string,
  contextPath?: string,
  method?: $Keys<HTTP_METHODS>,
  params?: string,
  data?: any,
  timeout?: number,
  responseType?: string,
  headers?: {
    [headerName: string]: string,
    Accept?: string,
    "Accept-Language"?: string,
    "Content-Type"?: string,
    "x-filename"?: string,
    "x-filesize"?: string,
  },
  events?: { [eventName: string]: () => void },
  onProgress?: ProgressEventHandler,
  includeContext?: boolean,
  locale?: string,
  cache?: boolean,
  isReload?: boolean,
  withCredentials?: boolean,
};

export type RequestOptions = { ...RequestURLOptions, ...RequestBaseOptions };

export type UpdateHandler = (newModel: ModularUIModel) => ModularUIModel;
export type RequestModularUIOptions = {
  ...RequestBaseOptions,
  targetModel?: TargetModel,
  forceTargetModel?: boolean,
  updateHandler?: UpdateHandler | void,
  childmodels?: boolean,
  isValidationRequest?: boolean,
  removeOnUnmount?: boolean,
};
